import { FormControlDirective } from '@angular/forms';
import { InputDirective } from './../../directives/input.directive';
import {
  Component,
  OnInit,
  ContentChild,
  Input,
  Optional
} from '@angular/core';
import { FormFieldComponent } from '../form-field/form-field.component';

@Component({
  selector: 'iq-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  host: {
    class: 'iq-checkbox-input'
  }
})
export class CheckboxInputComponent implements OnInit {
  @ContentChild(InputDirective)
  _control: InputDirective;

  @ContentChild(FormControlDirective)
  _formControl: FormControlDirective;

  @Input() label = '';

  constructor(@Optional() public parent: FormFieldComponent) {}

  ngOnInit() {}
}
